import { IconButtonProps, IconButton as MuiIconButton } from '@mui/material'
import React from 'react'
import { To, useNavigate } from 'react-router-dom'

type Props = IconButtonProps & {
    href?: To
}

const IconButton = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
    const navigate = useNavigate()
    const { href, ...rest } = props

    if (href) {
        return (
            <MuiIconButton
                {...rest}
                ref={ref}
                onClick={e => {
                    props.onClick?.(e)
                    navigate(href)
                }}
            />
        )
    }

    return <MuiIconButton {...rest} ref={ref} />
})

IconButton.displayName = 'IconButton'

export default IconButton
